<template>
  <app-stepper-section :label="$t('message.generics.message.generalData')">

    <v-text-field :label="$t('message.generics.message.name')"
                  v-model="name"
                  v-validate="'required'"
                  name="Nome"
                  :error-messages="errors.collect($t('message.generics.message.name'))"></v-text-field>

    <v-text-field :label="$t('message.generics.message.identifier')"
                  :value="cpfCnpj"
                  v-facade="cpfCnpjMask"
                  name="CPF/CNPJ"
                  v-validate="'required'"
                  :error-messages="errors.collect($t('message.generics.message.identifier'))"
                  return-masked-value
                  @input.native="emitDocument"></v-text-field>

    
    <app-select v-if="isEstablishment" class="use-type-dropdown" v-model="useType" data-title="Tipo" :data-search="false" :data-items="useTypeOptions" :clearable="false" />          

    <slot />

    <app-user-modal-footer v-if="step"
                           @click="advanceStep">{{$t('message.generics.message.advance')}}</app-user-modal-footer>

  </app-stepper-section>
</template>

<script>
    import AppStepperSection from '../../../StepperSection'
    import AppUserModalFooter from "@components/user-modal/components/UserModalFooter";
    import userModalSection from '../mixins/user-modal-section'
    import AppSelect from "@components/Select";
import EventBus from '../../../../packages/event-bus';


    export default {
        components: {
            AppStepperSection,
            AppUserModalFooter,
            AppSelect
        },

        data() {
            return {
                cpfCnpjMask: ['###.###.###-##', '##.###.###/####-##'],
            }
        },

        mixins: [userModalSection],

        props: {
            value: {
                type: Object
            },
            step: {
                type: Boolean,
                default: true
            },
            entity: {
                type: String,
            }
        },

        methods: {
            async advanceStep() {
                
                const isValid = await this.$validator.validateAll()

                if(this.isEstablishment && !this.useType) {
                    return EventBus.$emit("show-message", {
                        type: "ERROR",
                        message: 'O campo Tipo é obrigatório',
                    });
                }

                if(isValid) {
                    this.$emit('advance')
                }
            },
            emitDocument(event) {
                this.cpfCnpj = event.target.unmaskedValue
            }
        },

        computed: {
            isEstablishment() {
                return this.entity === "establishments";
            },
            name: {
                get() {
                    return this.value.name
                },
                set(name) {
                    this.$emit('input', {...this.value, name})
                },
            },

            cpfCnpj: {
                get() {
                    return this.value.cpfCnpj || ''
                },
                set(cpfCnpj) {
                    this.$emit('input', {...this.value, cpfCnpj})
                },
            },

            useType: {
                get() {
                    return this.value.useType || ''
                },
                set(useType) {
                    this.$emit('input', {...this.value, useType})
                },
            },

            useTypeOptions() {
                return [
                    {
                        id: 'ESTABELECIMENTO',
                        label: 'Estabelecimento'
                    },
                    {
                        id: 'HOTSPOT',
                        label: 'Hotspot'
                    },
                    {
                        id: 'REVENDA',
                        label: 'Revenda'
                    },
                ]
            }
        },
    }
</script>

<style scoped>
.use-type-dropdown ::v-deep .dropdown-menu {
  left: 0 ;
  right: auto ;
  transform: none ;
}
</style>
